import React, {useState, useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import axiosInstance from './../../http/axios';

import Toast from '../../toast';
import Header from './../header/Header';

import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";

import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';
import { Dialog, DialogTitle, Fab, Switch, TextField } from '@mui/material';
import DropdownMenu from '../dropdown_menu/DropdownMenu';
import {Pagination} from '@mui/material';
import AddRounded from '@mui/icons-material/AddRounded';
import { NavLink } from 'react-router-dom';
import LinearWithValueLabel from '../linear_progress_with_label/LinearProgressWithLabel';

const FakeChat = () => {

     const naviagte = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

     const location = useLocation();

     const chatGroupId = new URLSearchParams(location.search).get("chatGroupId");

    const [isSending, setIsSending] = useState(false);
    const [formData, setFormData] = useState({
        profilePhoto: null,
        userName: '',
        level: 1,
        vip: false,
        text: '',
        chatGroupId,
    })
    const onChange = (event)=>{
        const { value, name } = event.target;
        setFormData(pVal => {
             if(name.toLowerCase().indexOf("file") == -1){
                  return {
                       ...pVal,
                       [name]: value
                  };
             }
             else{
                  return {
                       ...pVal,
                       [name]: event.target.files[0]
                  };
             }
        });
        console.log(formData);
   }

     const [data, setData] = useState([]);
     const [maxLength, setMaxDataLength] = useState(0);
     const [isCreateDialogOpen, setCreateDialogOpen] = useState(false);
     const [errorMessage, setErrorMessage] = useState(null);
     const tableHead = ["User", "Level", "VIP/NON VIP", "Text", ""];

     const onPageChange = async (e, pageIndex) => {
          try {
               const params = new URLSearchParams();
               params.append("skip", 20 * (pageIndex-1));
               params.append("limit", 20);
               params.append("chatGroupId", chatGroupId);

               const res = await axiosInstance.get('admin/fake-chat-list', {
                    params: params
               });
               setErrorMessage(null);
               setData(res.data.data);
               setMaxDataLength(res.data.maxLength);
          } 
          catch (error) {
               setErrorMessage("Failed");
               console.log(error);
          }
     }

     useEffect(async ()=>{
          onPageChange(null, 1);
     }, []);

    const onSubmit = async ()=>{

        if(!formData.userName || !(formData.level+"") || !formData.text){
             Toast.error('Please enter valid details');
             return;
        }

        setIsSending(true)
        try {
             const rBody = new FormData();
             rBody.append('file', formData.file);
             rBody.append('userName', formData.userName);
             rBody.append('level', formData.level);
             rBody.append('vip', formData.vip);
             rBody.append('text', formData.text);
             rBody.append('chatGroupId', chatGroupId);
             const res = await axiosInstance.post("admin/fake-chat", rBody, 
                  {
                       headers: { "Content-Type": "multipart/form-data" },
                  }
             );
             setCreateDialogOpen(false);
             Toast.success('Created');
             setIsSending(false);
        } catch (error) {
             console.log(error);
             setIsSending(false);
             Toast.error('Failed.')
        }
    }

     return (
          <>
               <Header/>
               <div className="d-flex justify-content-between">
                    <div style={{height: '80px'}} className='d-flex align-items-center'>
                         {/* <IconButton onClick={()=>naviagte(-1)}><ArrowBackRounded/></IconButton> */}
                         <h5  style={{marginLeft: '10px', height: '100%', marginTop: '5px'}} className='d-flex align-items-center'>Fake Chat</h5>
                    </div>
                    <div className="d-flex align-items-center">
                         <div className='banner_create' onClick={()=> setCreateDialogOpen(true)}>
                              <AddRounded style={{color: '#fff'}}/>
                              <button>Create</button>
                         </div>
                    </div>
                    {/* <DropdownMenu items={["Active users", "Blocked users"]} onChange={(value, i)=> {
                              const status = i == 0 ? "active" : "blocked";
                              setUserAccountStatus(status);
                              onPageChange(null, 0, status);
                         }}/> */}
               </div>
               <div className="__table_root">
                    <table cellspacing="0" cellpadding="0" className="table">
                    <tr>
                         { tableHead.map((value, i)=> <th>{value}</th>) }
                    </tr>
                    { errorMessage ? null : ( data.length != 0 ? data.map((value, i)=> <Item data={value} position={i}/>) : null) }
                    </table>
                    { data.length != 0 ? null : <ErrorMessage message='Empty'/> }
                    { errorMessage ? <ErrorMessage message={errorMessage}/> : null }
                    <div className='d-flex justify-content-between'>
                    <div></div>
                         <Pagination onChange={onPageChange} count={maxLength != 0 ? ~~((maxLength/20)+1) : 0} shape="rounded" />
                    </div>
               </div>
               <Dialog
                open={isCreateDialogOpen}
                onClose={isSending?()=>{}:(b)=>setCreateDialogOpen(false)}>

                    <DialogTitle style={{width: "400px"}}>Create Chat Message</DialogTitle>
                                <div>
                                    <div style={{ width: '100%', marginLeft: '20px'}}>
                                        <div className='notification-import-image-root d-flex justify-content-center align-items-center' style={{marginTop: '20px'}}>
                                            { formData.file ? <img style={{height: '100%', width: '100%'}} src={URL.createObjectURL(formData.file)}/> : <div> <AddRounded /> Image </div> }
                                        </div>
                                        <label htmlFor="upload-photo" style={{marginTop: '10px'}}>
                                            <input name="file" onChange={onChange} style={{ display: 'none' }} id="upload-photo" type="file" itemType='image/*' />
                                            <Fab color="primary" size="small" component="span" aria-label="add" variant="extended">
                                                    <AddRounded /> Upload
                                            </Fab>
                                        </label>
                                    </div>
                                   <TextField name='userName' value={formData.userName} onChange={onChange} style={{width: '90%', marginLeft: "20px", marginTop: '10px', color: 'red'}} fullWidth label="User Name" type="text" inputProps={{ maxLength: 80 }}/>
                                   <div style={{width: '90%', marginLeft: "20px", marginTop: '20px', color: 'red'}} fullWidth>
                                    <span style={{color: 'gray'}}>VIP</span> <Switch value={formData.vip} name='vip' onChange={onChange}/>
                                    </div>
                                   <TextField name='level' value={formData.level} onChange={onChange} style={{width: '90%', marginLeft: "20px", marginTop: '20px', color: 'red'}} fullWidth label="User Level" type="number" inputProps={{ maxLength: 80 }}/>
                                   <TextField name='text' value={formData.text} onChange={onChange} style={{width: '90%', marginLeft: "20px", marginTop: '20px', color: 'red'}} fullWidth label="Message" type="text" multiline rows={4} inputProps={{ maxLength: 80 }}/>
                                </div>
                              <button onClick={onSubmit} style={{width: '90%', marginLeft: "20px", marginBottom: '20px', marginTop: '30px', cursor: isSending ? "progress" : 'pointer'}} className="__btn">Create</button>
                </Dialog>
          </>
     );
}

const Item = (props) => {
     const { _id, profilePhoto, userName, level, vip, text, date } = props.data;

     const [isDelete, setDelete] = useState(false);

     const naviagte = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

     const onDelete = async () => {
          setDelete(true);
          try {
               const rBody = new FormData();
               rBody.append("id", _id)
               const res = await axiosInstance.post("admin/fake-chat-delete", rBody, 
                    {
                         headers: { "Content-Type": "multipart/form-data" }
                    }
               )
          } 
          catch (error) {
               Toast.error("Failed to update");
               setDelete(false);
          }
     }

     if(isDelete) return null;

     return(
          <tr>
                <td><img src={profilePhoto} alt="" style={{borderRadius: '0px', width: '60px', height: '60px'}}/> {userName}</td>
               <td>{level}</td>
               <td>{vip?"VIP":"NON VIP"}</td>
               <td style={{maxWidth: '250px'}}>{text}</td>
               <td><button onClick={onDelete} style={{background: "red", border: "none", color: "white", padding: "5px 15px", borderRadius: "5px"}} >Delete Chat</button></td>
          </tr>
     );
};

const ErrorMessage = (props) => {
     return (
          <div className='d-flex align-items-center justify-content-center' style={{height: "300px", fontSize: '16px'}}>
               {props.message}
          </div>
     );
}

export default FakeChat;